import {
    productImageBackgroundGradient,
    productImageHoverBackgroundGradient,
} from "../../../design-tokens/01.colors/colors";
import { Box } from "../../layout/box/Box";
import { NextImage } from "../../media-and-icons/image/NextImage";
import { type CSSProperties, memo } from "react";

type ProductImageFrame = {
    src: string;
    priority?: boolean;
    alt: string;
    objectFit?: CSSProperties["objectFit"];
    quality?: number;
    isHovering?: boolean;
    sizes?: string[];
};

export const ProductImageFrame = memo(
    ({
        src,
        priority = false,
        alt,
        objectFit = "contain",
        quality = 75,
        isHovering = false,
        sizes = undefined,
    }: ProductImageFrame) => {
        return (
            <Box
                background={
                    isHovering
                        ? productImageHoverBackgroundGradient
                        : productImageBackgroundGradient
                }
                width={"100%"}
                height={"100%"}
            >
                <NextImage
                    src={src}
                    alt={alt}
                    objectFit={objectFit}
                    fill={true}
                    quality={quality}
                    priority={priority}
                    sizes={sizes}
                />
            </Box>
        );
    }
);

ProductImageFrame.displayName = "ProductImageFrame";

export default ProductImageFrame;
